import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import ReactHtmlParser from "react-html-parser";
import {
  admin_advertisement_delete,
  admin_advertisement_list,
  admin_notification_delete,
  admin_notification_list,
} from "../../admin.api";
import ManageScrolling from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
import { useParams } from "react-router-dom/cjs/react-router-dom";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const selectedParam = useParams();

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [view, setView] = useState(false);
  const [selectparam, setSelectParam] = useState(0);
  const [approveStatus, setApproveStatus] = useState(0);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownload = (item) => {
    let path = `${result}${item.advertisement}`;
    window.open(path, "_blank");
  };

  const handleEventList = () => {
    setIsActive(true);
    admin_advertisement_list().then((res) => {
      let tdata = res;
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   ...data,
    //   start_date: data.start_date ? new Date(data.start_date) : null,
    //   end_date: data.end_date ? new Date(data.end_date) : null,
    // }));

    // setView(false);
    // setEdit(true);
    // setAddNew(true);
    props.history.push(`/advertisements/edit/${data?.id}`);
  };

  const handleAddNew = () => {
    // setAddNew(true);
    // setView(false);
    props.history.push(`/advertisement/add`);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_advertisement_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const formatDate = (date) => {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleView = (data) => {
    //console.log(data)
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   ...data,
    //   file_name: data?.file_name,
    //   start_date: data.start_date ? new Date(data.start_date) : null,
    //   end_date: data.end_date ? new Date(data.end_date) : null,
    // }));
    // setAddNew(true);
    // setView(true);
    // setSelectParam(data?.id);
    // setApproveStatus(data?.status);
    props.history.push(`/advertisements/${data?.id}`);
  };

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Advertisement</b>
        </h6>
        <hr />
        {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: "Sl. No", type: "dynId" },
            { title: "Title", field: "title" },
            {
              title: "Advertisement",
              field: "advertisement",
              type: "download",
            },

            {
              title: "Start date",
              field: "start_date",
              type: "fullDateTime",
            },
            {
              title: "End date",
              field: "end_date",
              type: "fullDateTime",
            },

            { title: "Status", field: "status", type: "advertisementStatus" },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                  { type: "view", handleClick: handleView },
                  // { type: "edit", handleClick: handleEdit },
                  { type: "delete", handleClick: handleDelete },
                ]
              : [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                ]
          }
          handleDownload={handleDownload}
        />
      </div>
      {addNew && (
        <ManageScrolling
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
          adminType={adminType}
          selectedParam={selectparam}
          // isActive={isActive}
          approveStatus={approveStatus}
        />
      )}

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Advertisement ?"
          data={activeData}
          message="Are you sure to delete this advertisement?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
